var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Bg1200(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 409,
    viewBox: "0 0 1200 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.57 242.32H288.587V334.741H244.57V404.056H106.281V334.741H-50V256.972L128.887 5.07031H244.57V242.32Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.98 242.32H1251V334.741H1206.98V404.056H1068.69V334.741H912.413V256.972L1091.3 5.07031H1206.98V242.32Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M851.555 98.3585C830.694 67.7581 799.402 43.7149 757.68 26.2289C715.958 8.74298 663.635 0 600.709 0C569.247 0 540.349 2.35388 514.016 7.06164C488.026 11.4331 464.6 17.9904 443.739 26.7333C422.878 35.14 404.581 45.3962 388.85 57.5019C373.461 69.2713 360.465 82.722 349.864 97.8541C339.604 112.986 331.739 129.463 326.267 147.286C321.137 165.108 318.572 183.939 318.572 203.779C318.572 218.911 320.111 233.875 323.189 248.67C326.609 263.466 331.739 277.59 338.578 291.04C345.76 304.491 354.652 317.269 365.253 329.375C376.197 341.144 389.021 351.905 403.726 361.657C418.774 371.408 436.044 379.815 455.537 386.877C475.03 393.602 496.746 398.814 520.685 402.513C544.966 406.548 571.641 408.566 600.709 408.566C641.406 408.566 677.143 404.867 707.922 397.469C739.042 390.408 765.717 380.488 787.946 367.709C810.175 354.595 828.3 339.463 842.322 322.313C856.343 304.827 866.602 286.164 873.1 266.325C879.598 246.148 882.847 225.3 882.847 203.779C882.847 164.099 872.416 128.959 851.555 98.3585Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Bg1200);
export default __webpack_public_path__ + "static/media/404Bg1200.9af66bb8f3214e10b027c204714d7993.svg";
export { ForwardRef as ReactComponent };